// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"416":"aefd744490185d3f","629":"2ece6f66a5c259f8"}[chunkId] + ".css";
};